module.exports = __webpack_public_path__ + "static/media/about-header.99ff34a1.jpg";